import { ABOUT_STYLE } from "../../siteInfo/SiteStyle";
const aboutViewStyle = {
  aboutContainer: {},
  title: {
    fontSize: 30,
    color: "white",
    width: "100%",
    textAlign: "center",
    fontFamily: ABOUT_STYLE.mainFont,
  },
};
export default aboutViewStyle;
